export default __webpack_public_path__ + "img/sabira_am.572a0767.png";